export const searchDoctorInitialState = {
  filters: {
    name: "",
    clinic: "",
    skills: "",
    skillNames: "",
    serviceIds: "",
    serviceNames: "",
    fromCost: "",
    toCost: "",
    rating: "",
  },
  currentPage: 1,
  totalPages: 1,
  allUserList: [],
  isUserListLoading: false,
};

export const searchDoctorReducer = (state, action) => {
  switch (action.type) {
    case "SET_DOCTOR_FILTERS":
      return {
        ...state,
        filters: { ...state.filters, ...action.payload },
        currentPage: 1, // reset to page 1 when filters change
      };
    case "SET_DOCTOR_PAGE":
      return { ...state, currentPage: action.payload };
    case "SET_DOCTOR_DATA":
      return {
        ...state,
        allUserList: action.payload.data,
        totalPages: action.payload.totalPages,
        isUserListLoading: false,
      };
    case "SET_DOCTOR_LOADING":
      return { ...state, isUserListLoading: action.payload };
    case "RESET_DOCTOR_FILTERS":
      return {
        ...searchDoctorInitialState,
      };
    default:
      return state;
  }
};
